import { Component, OnInit } from '@angular/core';
import { sgkz001dConfig, SideMenuService } from 'sg-features';

/**
 * メイン画面
 * @export
 * @class MainComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  /**
   * コンストラクタ
   * @memberof MainComponent
   */
  constructor(private sideMenuService: SideMenuService) { }

  /**
   * 初期化処理
   * @memberof MainComponent
   */
  ngOnInit(): void {
    this.sideMenuService.updateSideMenu(sgkz001dConfig);
  }

}
